import { Component, HostListener, Input } from '@angular/core';

import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'sha-back-top',

  template: `
    <a  id="back-to-top"
        href="javascript:void(0)"
        class="btn btn-primary btn-lg back-to-top"
        role="button"
        title="{{ 'BACKTOP.TITLE' | translate }}"
        data-toggle="tooltip"
        data-placement="left"
        [class.show]="isVisible"
        (click)="backToTop()">
      <span class="glyphicon glyphicon-chevron-up"></span>
    </a>
  `,

  styles: [`
    .show{
      opacity: 1 !important;
    }

    .back-to-top {
      cursor: pointer;
      position: fixed;
      bottom: 20px;
      right: 20px;
      opacity: 0;
      transition: .5s ease-in-out all;
    }
  `]
})
export class BackTopComponent {
  @Input()
  scrollDuration = 100;

  isVisible = false;

  constructor() { }

  @HostListener('window:scroll', ['$event'])
  public windowScroll(event: any): void {
    this.isVisible = this.getScrollPosition() > 50;
  }

  private getScrollPosition(): number {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  public backToTop(): boolean {
    const start = this.getScrollPosition();
    const diff = -1 * start;
    const scrollStep = Math.PI / (this.scrollDuration / 10);
    let count = 0;

    const scrollInterval = setInterval(function () {
      count = count + 1;
      const currPos = start + diff * (0.5 - 0.5 * Math.cos(count * scrollStep));
      if (currPos > 0) {
        document.documentElement.scrollTop = currPos;
        document.body.scrollTop = currPos;
      } else {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        clearInterval(scrollInterval);
      }
    }, 10);

    return false;
  };
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/back-top/back-top.component.ts